<template>
    <a :href="'tel:'+phoneNumber" :class="phoneClass">
        <i class="el-icon-phone-outline"></i>
        <span class="phoneNumber">
            {{serverMobile}}
        </span>
    </a>

</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Phone',
  props: {
    phoneNumber: {
      type: Number,
      default: 4008860966
    },
    phoneClass: {
      type: String,
      default: 'white'
    },

  },
  data(){
      return {
        serverMobile:''
      }
  },
  created(){
      this.introductionTxt();
  },
  methods: {
    introductionTxt () {
       request({url: '/getTips ', method: 'get', data: {}}).then(response => {
            let res = response.data.data;
            this.serverMobile = res.serverMobile
       })
    }
  }

}
</script>
<style scoped>
    @import"./Phone.css";
</style>



// WEBPACK FOOTER //
// src/components/Phone/Phone.vue